
function connectedProductDesktop() {
    let connected_product_items = $('.connected_products_group_wrapper_desktop >  .connected_products_group').children()
    let connected_product_items_count = $(connected_product_items).length

    if (connected_product_items_count > 6) {
        $(connected_product_items).eq(5).addClass("last_visible_element")
        $(connected_product_items).eq(5).find('.product_image_select_color').addClass("last_visible_element_color")
        let connected_product_items_hidden_length = $(connected_product_items).eq(5).nextAll().length
        $(connected_product_items).eq(5).find('.product_image_select_color').append(`<h1>+${connected_product_items_hidden_length}</h1>`)
        $(connected_product_items).eq(5).nextAll().hide()
        $(connected_product_items).eq(5).find('a').addClass('linkDisabled')
    }

    $(connected_product_items).eq(5).on("click", function () {
        $(this).removeClass('last_visible_element')
        $(connected_product_items).eq(5).nextAll().show("fast")
        $(connected_product_items).eq(5).find('h1').remove()
        $(connected_product_items).eq(5).find('a').removeClass('linkDisabled')
        $(connected_product_items).eq(5).find('.product_image_select_color').removeClass("last_visible_element_color")

        $('.connected_products_group').addClass('connected_products_group_grid')

    })
  }
if ( $(window).width() > 767) {
    connectedProductDesktop()
}



